module.exports = __webpack_public_path__ + "static/img/kumc-competition.10339fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kumc-competition.jpg
// module id = q18H
// module chunks = 0